import { Add } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import AcxButton from "components/UI/AcxButton";
import { observer } from "mobx-react";
import React from "react";
import { VolumeControlQuota } from "../../Components/VolumeControlQuota";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../../Stores/LLMClassifierBuilderStore";
import { LLMClassifierExecuteConditions } from "../../Components/LLMClassifierExecuteConditions";

export const LLMClassifierVolumeControl = observer(() => {
    const store = useStore(LLMClassifierBuilderStore);

    return (
        <Grid container item direction="column" flexWrap="nowrap" rowGap={2}>
            <TitledSection
                title="Where to run this model"
                collapsible
                variant="bordered"
            >
                <Grid container direction="column" flexWrap="nowrap" rowGap={1}>
                    {store.modelComputeOption.modelComputeQuotas?.map(
                        (option, idx) => (
                            <VolumeControlQuota
                                key={option.id}
                                quota={option}
                                idx={idx}
                            />
                        ),
                    )}
                </Grid>
                <Grid item marginTop={2}>
                    <AcxButton
                        color="white"
                        startIcon={<Add />}
                        onClick={() => store.addModelComptueQuota()}
                        sx={(theme) => ({
                            color: theme.palette.primary.main,
                        })}
                    >
                        Hierarchy
                    </AcxButton>
                </Grid>
            </TitledSection>
            <TitledSection title="Metadata Filters" variant="bordered">
                <LLMClassifierExecuteConditions />
            </TitledSection>
        </Grid>
    );
});
